import { render, staticRenderFns } from "./newexamdetail.vue?vue&type=template&id=29b0cd0a&scoped=true&"
import script from "./newexamdetail.vue?vue&type=script&lang=js&"
export * from "./newexamdetail.vue?vue&type=script&lang=js&"
import style0 from "./newexamdetail.vue?vue&type=style&index=0&id=29b0cd0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b0cd0a",
  null
  
)

export default component.exports